import type { RootState } from "types/redux";

export const getTopicsFilterSelectedIds = (state: RootState) => state.domains.filters.topics.selectedIds;
